import React from "react";
import banner1 from "../../assets/images/contact.png";
import UnderCons from "../../assets/images/underconstruction.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../assets/css/style.css"

const Blog = () => {
    return (
        <div>
            <div class="banner-two banner-aggregators">
                <img src={banner1} alt="" />
            </div>
            <div class="banner-bottom">
                <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 text-center banner-bottom-text">
                                <h4>Blog </h4>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="under-constrution">
                <div class="container">
                    <img src={UnderCons} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Blog;